"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, pad) {
  return ("" + pad + value).slice(-pad.length);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/padLeft.js
// module id = 800
// module chunks = 0